import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Hero from "../Components/Hero";
import Fitur from "../Components/About";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar/index";
import About from "../Components/Fitur";
import NewsSection from "./news/news";
import DonasiBarangSection from "../Components/About/donasibarang";

const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("device_id", deviceId);
  }

  return deviceId;
};

const HEADER_HEIGHT = 96;
const LandingPageUdin: React.FC = () => {
  const [currentPage, setCurrentPage] = useState("Beranda");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const berandaRef = useRef<HTMLDivElement>(null);
  const fiturRef = useRef<HTMLDivElement>(null);
  const visimisiRef = useRef<HTMLDivElement>(null);
  const jenisGeraiRef = useRef<HTMLDivElement>(null);
  const programRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const recordVisitor = async () => {
      try {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/visitor/record`, {
          website_code: "sumatera",
          device_id: getDeviceId(),
        });
      } catch (error) {
        console.error("Gagal record visitor", error);
      }
    };

    recordVisitor();
  }, []);

  const handleMenuClick = (page: string) => {
    if (page === "Merchant Bisnis") {
      setCurrentPage(page);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return;
    }

    setCurrentPage(page);

    setTimeout(() => {
      const targetRef = {
        Beranda: berandaRef,
        "Donasi Barang": programRef,
        "Campaign ": fiturRef,
        "Galang Dana": visimisiRef,
        Berita: jenisGeraiRef,
      }[page];

      if (targetRef?.current) {
        window.scrollTo({
          top: targetRef.current.offsetTop - HEADER_HEIGHT,
          behavior: "smooth",
        });
      }
    }, 100); // Memberi waktu agar komponen bisa update sebelum scroll

    setIsMenuOpen(false);
  };

  return (
    <section className="font-signika  mx-auto ">
      <div className="fixed top-0 left-0 w-full z-40 bg-white">
        <Navbar currentPage={currentPage} isMenuOpen={isMenuOpen} handleMenuClick={handleMenuClick} setIsMenuOpen={setIsMenuOpen} />
      </div>

      <section className="pt-[80px] grid grid-cols-1">
        <>
          <div ref={berandaRef}>
            <Hero handleMenuClick={handleMenuClick} />
          </div>

          <div ref={programRef}>
            <DonasiBarangSection />
          </div>

          <div ref={fiturRef}>
            <Fitur />
          </div>

          <div ref={visimisiRef}>
            <About />
          </div>

          <div ref={jenisGeraiRef}>
            <NewsSection />
          </div>

          <Footer handleMenuClick={handleMenuClick} />
        </>
      </section>
    </section>
  );
};

export default LandingPageUdin;
